import React, { FunctionComponent } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';

import { PdpRequestAppointmentModalLoader_item } from './__generated__/PdpRequestAppointmentModalLoader_item.graphql';
import { PdpRequestAppointmentModalLoader_user } from './__generated__/PdpRequestAppointmentModalLoader_user.graphql';

const PdpRequestAppointmentModal = React.lazy(() =>
    import(/* webpackChunkName: "PdpRequestAppointmentModal" */ './PdpRequestAppointmentModal')
);

type Props = {
    isModalOpen: boolean;
    closeModal: () => void;
    item: PdpRequestAppointmentModalLoader_item;
    user: PdpRequestAppointmentModalLoader_user;
};

const PdpRequestAppointmentModalLoaderComponent: FunctionComponent<Props> = ({
    isModalOpen,
    closeModal,
    item,
    user,
}) => {
    return isModalOpen ? (
        <React.Suspense fallback={null}>
            <PdpRequestAppointmentModal onClose={closeModal} item={item} user={user} />
        </React.Suspense>
    ) : null;
};

const PdpRequestAppointmentModalLoader = createFragmentContainer(
    PdpRequestAppointmentModalLoaderComponent,
    {
        user: graphql`
            fragment PdpRequestAppointmentModalLoader_user on User {
                ...PdpRequestAppointmentModal_user
            }
        `,
        item: graphql`
            fragment PdpRequestAppointmentModalLoader_item on Item {
                ...PdpRequestAppointmentModal_item
            }
        `,
    }
);

export default PdpRequestAppointmentModalLoader;
